<template>
  <div class="">
    <div class="condition clearfix" id="">
      <el-form :inline="true" :model="conditions" class="demo-form-inline clearfix" ref="conditions">
        <div class="clearfix" style="margin-bottom: 10px;">
          <!-- search start-->
          <!-- <el-form-item label="单据状态：" class="tinp">
                <el-select v-model="conditions.statu" clearable class="myselect" @change="onParamChange">
                  <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item> -->
          <!-- <el-form-item label="退货单号：" class="tinp">
                    <el-input v-model="conditions.vbillcode" placeholder="请输入申请单号" suffix-icon="el-icon-search" clearable @change="onParamChange"></el-input>
                </el-form-item> -->
          <!-- <el-form-item  label="选择供应商：" class="tinp">
              <el-select @change="changesearch"  filterable value-key="suppliercode" v-model="conditions.suppliername" clearable placeholder="请选择供应商" style="width:100%;" auto-complete="off">
                <el-option v-for="item in supplierList" :key="item.suppliercode" :label="item.suppliername" :value="item"></el-option>
              </el-select>
          </el-form-item>  -->
<!--          <el-form-item label="采购订单号：" prop="ordercode" class="tinp tuitip gongying">-->
<!--            <el-input v-model="conditions.ordercode" placeholder="请输入订单编号" prefix-icon="el-icon-edit" clearable  ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item label="供应商名称：" prop="suppliername" class="tinp tuitip">
           <el-autocomplete
              class="inline-input"
              v-model="conditions.suppliername"
              :fetch-suggestions="querySearch"
              placeholder="请输入内容"
              :trigger-on-focus="false"
              @select="handleSelect"
              clearable>
              <i
                class="el-icon-search el-input__icon"
                slot="prefix">
              </i>
           </el-autocomplete>
          </el-form-item>
         <!--  <el-form-item label="供应商编码：" class="tinp">
            <el-input v-model="conditions.suppliercode" placeholder="请输入供应商编码" suffix-icon="el-icon-search" clearable @change="changesearch"></el-input>
          </el-form-item>
          <el-form-item label="供应商名称：" class="tinp">
            <el-input v-model="conditions.suppliername" placeholder="请输入供应商名称" suffix-icon="el-icon-search" clearable @change="changesearch"></el-input>
          </el-form-item> -->
          <!--  <el-form-item label="申请时间：" class="tinp searchtime":class="{iconshow:showicon}">
               <el-date-picker value-format="yyyy-MM-dd" v-model="conditions.time" type="date" placeholder="选择日期" @change="getList"  @mouseover.native="cleandataicon" @mouseout.native="cleandataicon" >
              </el-date-picker>
            </el-form-item> -->
          <!--  <el-form-item label="申请人：" class="tinp">
                    <el-input v-model="conditions.billmaker" placeholder="请输入申请人" suffix-icon="el-icon-search" clearable @change="getList"></el-input>
                </el-form-item> -->
          <!-- search end -->
          <el-button type="primary" class="" style="margin-left: 20px" size="small" icon="el-icon-search" @click="onParamChange" v-loading.fullscreen.lock="fullscreenLoading">搜索</el-button>
          <el-button type="primary" class="fr" style="margin-right: 20px" size="small" icon="el-icon-plus" @click="addlist">新增退货单 </el-button>
        </div>
        <!-- tablelist1 start -->
        <div class="tablebox" style="margin-top: 0px;" v-if="count >=1">
          <table style="width: 1146px !important;margin-bottom:16px" v-for="(item,index) in tableList">
            <tr style="border: 1px solid #56B8AA;background:#fff;color: #333;height:45px">
              <th :id="item.vbillcode" style="width:2rem;font-color:#56B8AA;background-color:#fff;position:relative" @click="showlist(item,index)">
                <i class="iconfont icon-jiantou_yemian_xiangshang jiantouxia" v-bind:class="{'jiantoushang':item.listshow =='N'}" style="color: #56B8AA;font-size: 22px;font-weight: 100;"></i></th>
              <th colspan="11">
                <span class="fl tabletitle">退货单号：{{item.vbillcode}}</span>
                <span class="fl tabletitle">退货单日期：{{item.dmakedate}}</span>
                <!-- <span class="fr tabletitle">制单人：{{item.billmakername}}</span>  -->
                <span class="fr tabletitle">快递单号：{{item.couriernumber}}</span>
                <span class="fr tabletitle">快递公司：{{item.couriername}}</span>
                <span class="fr tabletitle">供应商：{{item.suppliername}}</span>
<!--                <span class="fr tabletitle">采购订单号：{{item.ordercode}}</span>-->
                <!-- <span class="fr tabletitle">退货总数：{{item.nnjum}}</span>   -->
              </th>
            </tr>
            <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px" v-show="item.listshow =='N'">
              <th style="width:">行号</th>
              <th style="border: 1px solid rgb(86, 184, 170);" v-for="head in tableHeads">{{ head.label }}</th>
            </tr>
            <tr class="trbg" v-for="(data,index2) in item.productList" :key="item.pkApplybillB" v-show="item.listshow =='N'">
              <td style="border: 1px solid #56B8AA; height: 38px;">{{index2+1}}</td>
              <td v-for="head in tableHeads" style="border: 1px solid #56B8AA; height: 38px;">
                <span>{{data[head.key]}}</span>
              </td>
            </tr>
          </table>
        </div>
        <!-- tablelist1 end -->
        <div class="msgNone" v-else style="text-align: center;font-size: 15px;color: #333;margin-top: 20px">
          暂无数据
        </div>
        <!-- fenye start -->
        <div class="block" style="text-align: center;margin:20px auto ">
          <span>
            <el-pagination class="fenye" @size-change="handleSizeChange" @current-change="handleCurrentChange"  background
              :current-page="page"
              :page-size="pagesize"
              layout="total,  prev, pager, next, jumper"
              :total="count">
            </el-pagination>
            </span>
        </div>
        <!-- fenye end -->
      </el-form>
    </div>
    <!-- model end -->
    <div class="" v-loading.fullscreen.lock="fullscreenLoading"></div>
   <!-- 弹窗 start -->
      <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel>
  </div>
</template>
<script>
import { getElementsByClassName } from '../../../static/js/cookie.js'
export default {
  name: '',
  data() {
    return {
      flag:false,
      modelFlag:false,
      msgShow:false,
      modelFlag2:false,
      butflag:true,
      butflag2:true,
      msg:'',
      butmsg:'确认',
      butmsg2:'确认',
      methodName:'',
      utilpath: '',
      page: 1,
      pagesize: 10,
      count: 0,
      id: '',
      index: 0,
      supplierList:[],
      row: 0,
      changebgcolor: -1,
      user: {},
      fullscreenLoading: false,
      showicon: false,
      diaoboshow: false,
      statu: 0,
      statuname: '已申请',
      status: [{
          label: '已申请',
          value: 0
        },
        {
          label: '已完成',
          value: 1
        },
        {
          label: '被拒绝',
          value: 2
        },
      ],
      conditions: {
        suppliercode: '',
        suppliername: '',
        ordercode: '',
        vbillcode: '', //申请单号
        productName: '', //商品名称
        time: '', //申请时间
        statu: 0, //申请状态
      },
      tableList: [],
      tableData: {},
      tableinput: {},
      tableHeads: [
        // {
        //        label: '退货仓库',
        //        key: 'repertoryname'
        //    },
        // {
        //        label: '退货货位',
        //        key: 'positionname'
        //    },
        {
          label: '商品编码',
          key: 'productCode'
        },
        {
          label: '商品名称',
          key: 'productName'
        },
        {
          label: '规格',
          key: 'wlspec'
        },
        {
          label: '型号',
          key: 'wltype'
        },
        {
          label: '主单位',
          key: 'cunitname'
        },
        // {
        //     label: '批次号',
        //     key: 'vbatchcode'
        // },
        {
          label: '退货数量',
          key: 'nznum'
        }
      ],
      InterfacePath: ''
    }
  },
  mounted() {
    // 获取接口名
    this.InterfacePath = window.localStorage.getItem("InterfacePath");
    this.utilpath = this.axios.defaults.baseURL;
    this.init();
    this.getsupplier();
  },
  destroyed() {
    sessionStorage.removeItem("vbillcode");
    sessionStorage.removeItem("billmaker");
    sessionStorage.removeItem("productName");
    sessionStorage.removeItem("time");
    sessionStorage.removeItem("page");
    sessionStorage.removeItem("pagesize");
    sessionStorage.removeItem("tuihuolist");
    // console.log("清除session");
  },
  methods: {
    querySearch(queryString, cb) {
        var restaurants = this.supplierList;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
handleSelect(item) {
    this.conditions.suppliercode= item.suppliercode;
    this.conditions.suppliername= item.value;
    // this.list.telephone= item.telephone;
    // this.getList();
},
    returnMsg(flag){
      this.modelFlag = false;
      if(flag){
             // console.log("---进来了！！！----"+this.methodName);
            if(this.methodName =='---'){
                var reqparams={
                  storecode:this.users.storecode,
                  productCode:this.productCode
                }
                // console.log("---参数！！！----"+JSON.stringify(this.reqparams));
                this.$http.post(this.utilpath+'/delettePrabillB',reqparams,{emulateJSON:true,_timeout:600}).then((res)=>{
                    if(res.data.status == '0'){

                    } else if(res.data.status == '9'){
                      this.fullscreenLoading =false;
                      this.$router.push({path:'/ui/login',query:{msg:9}});
                    } else{
                      this.modelFlag = true;
                      this.msgShow = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了';
                      //  this.$alert('门店请购单信息删除失败', '失败信息', {
                      //   confirmButtonText: '确定'
                      // });
                    }
                }, (err) => {
                  this.modelFlag = true;
                  this.msgShow = false;
                  this.methodName = 'message';
                  this.msg = '获取接口失败'+err;
                  this.butflag =false;
                  this.butmsg='知道了';
                })
            }
      }else{
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    },
    getsupplier(){
              //获取数据接口
        var reqParam = {
          storecode:this.user.storecode
        };
        // this.$http.get('api/selectSupplier').then((res) => {
        this.$http.post(this.utilpath+'/selectSupplierInfo',reqParam,{emulateJSON:true,_timeout:600}).then((res) => {
        // this.$http.post('/ktnapi/selectSupplierInfo',reqParam,{emulateJSON:true}).then((res) => {
        // this.$http.post(this.InterfacePath+'/selectSupplierInfo',reqParam,{emulateJSON:true}).then((res) => {
                    if(res.data.status == '0'){
                        var suppliers=res.data.resultList;
                        this.supplierList=[];
                        for(var i=suppliers.length-1;i>-1;i--){
                            this.supplierList.push({value:suppliers[i].suppliername,suppliercode:suppliers[i].suppliercode,telephone:suppliers[i].telephone});
                        }
                    } else if(res.data.status == '9'){
                      this.fullscreenLoading =false;
                      this.$router.push({path:'/ui/login',query:{msg:9}});
                    } else{
                      this.supplierList = [];
                    }
                }, (err) => {
                    console.log(err);
                });
    },
    //显示隐藏表格
    showlist(item, index) {
      // console.log("展开方法");
      // 取反(true或false)
      this.tableList[index].listshow = item.listshow == 'Y' ? 'N' : 'Y';
      for (var i = 0; i < this.tableList.length; i++) {
        if (i != index) {
          this.tableList[i].listshow = 'N';
        }
      }
      this.id = item.vbillcode;
      this.toTop();
    },
    toTop() {
      var idmsg = '';
      if (this.id != '') {
        idmsg = this.id;
      } else {
        idmsg = 'contain';
      }
      //参数i表示间隔的幅度大小，以此来控制速度
      var dis = (document.getElementById(idmsg).scrollTop) / 8
      this.step = dis;
      document.getElementById(idmsg).scrollTop -= dis;
      var scroll = document.getElementById(idmsg).scrollTop;
      if (scroll > 0) {
        // console.log("回到顶部循环内" + document.getElementById(idmsg).scrollTop);
        this.step += dis
        var c = setTimeout(() => this.toTop(this.step), 16);
      } else {
        clearTimeout(c);
      }
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pagesize = val;
      this.page=1;
      this.getList();
      // console.log(this.pagesize);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.page = val;
      // console.log(this.page);
      this.fullscreenLoading = true;
      this.getList();
    },
    addlist() {
      this.$router.push({ path: '/ui/order/qutuihuo/zengtui' });
    },
    cleandataicon() {
      if (this.conditions.time != '') {
        this.showicon = !this.showicon;
      }
      if (this.conditions.time == null) {
        this.showicon = false;
      }
    },
    changesearch(value){
      // console.log("进入change事件");
      this.page=1;
      // this.conditions.suppliercode= value.suppliercode;
      // this.conditions.suppliername= value.suppliername;
      this.fullscreenLoading = true;
      if(this.conditions.suppliername==null||this.conditions.suppliername==''||this.conditions.suppliername==undefined){
          this.conditions.suppliercode==''
      }
      // this.getList();
    },
    //获取数据this.buyType==''?0:this.buyType
    getList() {
      if((this.conditions.suppliername==null)||(this.conditions.suppliername=="")||(this.conditions.suppliername==undefined)){
          this.conditions.suppliercode=''
      }
      // console.log((this.conditions.suppliername=="")+"打印供应商："+JSON.stringify(this.conditions));
      var reqParam = {
        storecode: this.user.storecode,
        suppliercode: this.conditions.suppliercode==undefined?'':this.conditions.suppliercode,
        ordercode: this.conditions.ordercode==undefined?'':this.conditions.ordercode,
        // vbillcode: this.conditions.vbillcode,//申请单号
        fbillstatus: '1', //单据状态
        // productName: this.conditions.productName, //商品名称
        // time: this.conditions.time, //申请时间
        pageNum: this.page, //当前页
        pageSize: this.pagesize //页面数据条数
      }
      sessionStorage.setItem("vbillcode", this.conditions.vbillcode);
      sessionStorage.setItem("statu", JSON.stringify(this.conditions));
      sessionStorage.setItem("productName", this.conditions.productName);
      sessionStorage.setItem("time", this.conditions.time);
      sessionStorage.setItem("page", this.page);
      sessionStorage.setItem("pagesize", this.pagesize);
      //获取数据接口
      // this.$http.post('api/goods', reqParam).then((res) => {
      // this.$http.post(this.InterfacePath+"/ktnapi/selectReturnbill",reqParam,{emulateJSON:true}).then((res)=>{
      this.$http.post(this.utilpath + '/selectReturnbill', reqParam, { emulateJSON: true,_timeout:600}).then((res) => {
        // this.$http.post("ktnapi/selectApplyBill",reqParam,{emulateJSON:true}).then((res)=>{
        if (res.data.status == '0') {
          this.fullscreenLoading = false;
          // this.tableList=res.data.result;
          this.tableList = res.data.resultList;
          this.count = res.data.countNum;
          sessionStorage.setItem("tuihuolist", JSON.stringify(this.tableList));
        } else if (res.data.status == '-1') {
          this.fullscreenLoading = false;
          this.count = 0;
          this.tableList=[];
          this.$message({
            showClose:true,
            message:'暂无数据！',
            type:'info'
          })
        } else if(res.data.status == '9'){
          this.fullscreenLoading =false;
          this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.fullscreenLoading = false;
          this.modelFlag = true;
          this.msgShow = true;
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了';
        }
      }, (err) => {
        this.fullscreenLoading = false;
        this.msgShow = false;
        this.modelFlag = true;
        this.methodName = 'message';
        this.msg = '连接查询门店退货单接口失败';
        this.butflag =false;
        this.butmsg='知道了';
      });
    },
    //
    changerpwcolor(index) {
      this.changebgcolor = index;
    },
    init() {
      this.user = JSON.parse(window.localStorage.getItem("userInfo"));
      var inp1 = sessionStorage.getItem("vbillcode");
      var inp2 = JSON.parse(sessionStorage.getItem("statu"));
      var inp3 = sessionStorage.getItem("productName");
      var inp4 = sessionStorage.getItem("time");
      if (inp1 != null) {
        this.conditions.vbillcode = inp1;
      }
      if (inp2 != null) {
        this.conditions = inp2;
      }
      if (inp3 != null) {
        this.conditions.productName = inp3;
      }
      if (inp4 != null) {
        this.conditions.time = inp4;
      }
      if (this.conditions.statu == '0') {
        this.statuname = '已申请'
      } else if (this.conditions.statu == '1') {
        this.statuname = '已完成'
      } else if (this.conditions.statu == '2') {
        this.statuname = '被拒绝'
      }
      var bigdata = JSON.parse(sessionStorage.getItem("tuihuolist"));
      // console.log("初始化打印数据："+JSON.stringify(bigdata));
      if (bigdata != null) {
        this.fullscreenLoading =false;
        this.tableList = bigdata;
        this.count = this.tableList.length;
        this.page = parseFloat(sessionStorage.getItem("page"));
        this.pagesize = parseFloat(sessionStorage.getItem("pagesize"));
      } else {
        // this.getList();
      }
    },
    modify(index, index2, id) {
      this.id = id;
      this.index = index;
      this.row = index2;
      this.tableData = JSON.parse(JSON.stringify(this.tableList[index].productList[index2]));
      this.tableinput = this.tableList[index];
      this.tableinput.modifiedtime = '';
      this.diaoboshow = true;
    },
    closemodel() {
      this.diaoboshow = false;
      this.tableData = {};
      this.tableinput = {};
    },
    sumbittable() {
      var pram = {
        minstorecode: this.user.storecode,
        applybillB: JSON.stringify(this.tableData),
        vbillcode: this.conditions.vbillcode, //申请单号
        fbillstatus: this.conditions.statu, //单据状态
        productName: this.conditions.productName, //商品名称
        time: this.conditions.time, //申请时间
        page: this.page, //当前页
        pagesize: this.pagesize //页面数据条数
      }
      // this.$http.post("api/goods",this.tableData).then((res)=>{
      this.$http.post(this.utilpath + '/updateApplyBillBOneInfo', pram, { emulateJSON: true ,_timeout:600}).then((res) => {
        // this.$http.post(this.InterfacePath+"/updateApplyBillBOneInfo",pram,{emulateJSON:true}).then((res)=>{
        // this.$http.post("ktnapi/updateApplyBillBOneInfo",pram,{emulateJSON:true}).then((res)=>{
        if (res.data.status == '0') {
          this.diaoboshow = false;
          this.$message({
            showClose: true,
            type: 'succcess',
            message: '修改成功'
          })
          // this.tableList=res.data.result;
          this.tableList = res.data.resultList;
          this.tableData = {};
        } else if(res.data.status == '9'){
          this.fullscreenLoading =false;
          this.$router.push({path:'/ui/login',query:{msg:9}});
        }  else {
          this.modelFlag = true;
          this.msgShow = true;
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了';
          // this.$alert(res.data.message, '失败信息', {
          //   confirmButtonText: '确定'
          // });
        }
      }, (err) => {
        this.modelFlag = true;
        this.msgShow = false;
        this.methodName = 'message';
        this.msg =err
        this.butflag =false;
        this.butmsg='知道了';
      });
      // this.tableinput ={};
    },
    //搜索框变化事件
    onParamChange() {
      this.page = 1;
      this.getList();
      // this.statu = JSON.stringify(this.conditions.statu);
      // if (this.statu == '0') {
      //   this.statuname = '已申请'
      // } else if (this.statu == '1') {
      //   this.statuname = '已完成'
      // } else if (this.statu == '2') {
      //   this.statuname = '被拒绝'
      // }
      // sessionStorage.setItem("tuihuolist", JSON.stringify(this.tableList));
      // sessionStorage.setItem("statu", JSON.stringify(this.conditions));
    }
  }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/order/qutuihuo.vue